export interface CsvRow {
  key: string;
  value: string;
  group: string;
}

function parseCsvLine(line: string): string[] {
  const fields: string[] = [];
  let i = 0;
  while (i <= line.length) {
    if (line[i] === '"') {
      i++;
      let field = "";
      while (i < line.length) {
        if (line[i] === '"') {
          if (line[i + 1] === '"') {
            field += '"';
            i += 2;
          } else {
            i++;
            break;
          }
        } else {
          field += line[i++];
        }
      }
      fields.push(field);
      if (line[i] === ",") i++;
    } else {
      const end = line.indexOf(",", i);
      if (end === -1) {
        fields.push(line.slice(i));
        break;
      }
      fields.push(line.slice(i, end));
      i = end + 1;
    }
  }
  return fields;
}

export function parseScenarioCsv(csv: string): CsvRow[] {
  const lines = csv
    .trim()
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .split("\n");
  const header = parseCsvLine(lines.shift() ?? "");
  if (header[0] !== "key") throw new Error("Invalid CSV header");

  return lines
    .filter((line) => line.trim() !== "")
    .map((line) => {
      const cols = parseCsvLine(line);
      return {
        key: cols[0] ?? "",
        value: cols[1] ?? "",
        group: cols[2] || "assumptions",
      };
    });
}
